import React, { useEffect, useState } from "react";
import { useLocation, useNavigate, useSearchParams } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { Box, Grid, IconButton, Typography } from "@mui/material";
import MoreIcon from "@mui/icons-material/MoreVert";
import ArrowBackIosRoundedIcon from "@mui/icons-material/ArrowBackIosRounded";
import { getReservationDetails } from "redux/actions/reservationAction";
import DispatchModal from "pages/operation/allot/DispatchModal";
import AllotVehicleModal from "pages/operation/allRides/AllotVehicleModal";
import CommonTableDialog from "components/commonTableDialog/CommonTableDialog";
import CommonButton from "components/commonButton/CommonButton";
import Loader from "components/loader/Loader";
import {
  formatCurrency,
  getDateFormat,
  getReservationDetailsObject,
  handlePermissions,
  isValidTripTime
} from "utils/utils";
import { roleAndPermissionEnum } from "utils/rolesPermissionsEnum";
import { billingTypeEnum } from "utils/enumObj";
import useModal from "hooks/useModal";
import {
  allotDialogMenu,
  bookingDetailsData,
  bookingTime,
  allotMoreMenu,
} from "./BookingDetailsData";
import Wifi from "assets/images/Wifi.svg";
import Snack from "assets/images/Snack.svg";
import Charger from "assets/images/Charger.svg";
import NewsPaper from "assets/images/NewsPaper.svg";
import WaterBottle from "assets/images/WaterBottle.svg";
import AssignmentActionDetails from "./AssignDriverHistory";

const BookingDetails = () => {
  const { open: allotModal, toggle: setAllotModal } = useModal();
  const { open: dispatchModal, toggle: setDipatchmodal } = useModal();

  const [open, setOpen] = useState(false);
  const [dialogMenu, setDialogMenu] = useState(false);

  const navigate = useNavigate();
  const location = useLocation();
  const dispatch = useDispatch();
  const { state } = location;
  const [searchParams, setSearchParams] = useSearchParams()
  const id = searchParams.get('id');
  const startDate = searchParams.get('startDate');
  const endDate = searchParams.get('endDate');
  const type = searchParams.get('type');
  const page = searchParams.get('page');
  const rowPerPage = searchParams.get('rowPerPage');
  const search = searchParams.get('search');
  const tab = searchParams.get('tab');

  const tripDetails = useSelector(
    (state) => state.getReservationDetails?.reservationDetails?.data
  );
  const reservationDataLoading = useSelector(
    (state) => state.getReservationDetails?.loading
  );
  const CabFacilities = tripDetails?.facilities;
  const tripStatus = tripDetails?.status?.toLowerCase();

  const details = getReservationDetailsObject(tripDetails);
  const role = localStorage.getItem("role");
  const pageType = location?.pathname?.split("/")[1];

  useEffect(() => {
    if(id){
      dispatch(getReservationDetails(id));
    }
    btnText(tripDetails?.status);
  }, []);

  //roles and permissions 
  const roleAndPermissions = useSelector((state) => state?.getRolesAndPermissions?.rolesAndPermissions);
  const reservationRoleEnum = roleAndPermissionEnum.reservation
  const operationRoleEnum = roleAndPermissionEnum.operation

  const accessForall = handlePermissions(roleAndPermissions, reservationRoleEnum.moduleKey, {defaultAllAccess: reservationRoleEnum.all});
  const accessForOnlyView = handlePermissions(roleAndPermissions, reservationRoleEnum.moduleKey, {customAccess: reservationRoleEnum.view});
  const accessForEdit = handlePermissions(roleAndPermissions, reservationRoleEnum.moduleKey, {customAccess: reservationRoleEnum.edit});
  const accessForAdd = handlePermissions(roleAndPermissions, reservationRoleEnum.moduleKey, {customAccess: reservationRoleEnum.add});
  const accessForCancel = handlePermissions(roleAndPermissions, reservationRoleEnum.moduleKey, {customAccess: reservationRoleEnum.cancel});

  const cancelAccess = (accessForall || accessForCancel)

  //roles and permissions for operations
  const accessForAllot = handlePermissions(roleAndPermissions, operationRoleEnum.moduleKey, {customAccess: operationRoleEnum.allRides.allRidesAllot});
  const accessForDispatch = handlePermissions(roleAndPermissions, operationRoleEnum.moduleKey, {customAccess: operationRoleEnum.allotTrip.allotTripDispatch});
  const accessForDispatchCancel = handlePermissions(roleAndPermissions, operationRoleEnum.moduleKey, {customAccess: operationRoleEnum.dispatch.dispatchCancel});
  const accessForGenerate = handlePermissions(roleAndPermissions, operationRoleEnum.moduleKey, {customAccess: operationRoleEnum.billing.billingGenerate});

  const editAccess = (accessForAllot || accessForDispatch ||accessForGenerate)
  const reservationEdit = (accessForall||accessForEdit)

  useEffect(() => {
    if (tripStatus === "booked" || tripStatus ==='pending') {
      setDialogMenu(allotDialogMenu);
    } else if (tripStatus === "alloted" && role === "adminCompany") {
      setDialogMenu(allotDialogMenu);
    } else if (tripStatus === "alloted" && accessForDispatch) {
      setDialogMenu(allotMoreMenu);
    } else if (tripStatus === "dispatched" && accessForDispatchCancel) {
      setDialogMenu(allotDialogMenu);
    } else {
      setDialogMenu("");
    }
  }, [tripDetails]);

  const btnText = (status) => {
    if (pageType === "reservation") {
      switch (status) {
        case "booked":
        case "pending":
          return "Edit";
        case "alloted":
          return "Edit";
        default:
          return "";
      }
    } else if (pageType === "operation") {

      if(status === "booked" && accessForAllot) {
        return "Allot Duty";
      }
      else if (status === "alloted" && accessForDispatch) {
        return "Dispatch Duty";
      } else if (status === "cancelled") {
        return "Generate Invoice";
      } else {
        return "";
      }
    }
  };

  let btnName = btnText(tripStatus);

  // ---For Image Error---
  const handleOnError = (e, facilityName) => {
    let replacementImage;
    switch (facilityName) {
      case "Wifi":
        replacementImage = Wifi;
        break;
      case "Snack":
        replacementImage = Snack;
        break;
      case "Charger":
        replacementImage = Charger;
        break;
      case "News Paper":
        replacementImage = NewsPaper;
        break;
      case "Water Bottel":
        replacementImage = WaterBottle;
        break;
      default:
        replacementImage = Wifi;
    }
    e.target.src = replacementImage;
  };

  const handleDisabledBtn = (btnName) => {
    if (
      (btnName?.toLowerCase() === "edit" &&
        !isValidTripTime(tripDetails?.scheduledTime)) ||
      tripDetails?.Invoices?.length > 0
    ) {
      return true;
    }
  };

  const actionBtn = (status, tripDetails) => {
    if (pageType === "reservation") {
      if (status === "booked" || status === "alloted" || status === "pending") {
        const dateStatus = isValidTripTime(tripDetails?.scheduledTime);
        if (dateStatus) {
          navigate("/reservation/new-reservation", {
            state: { edit: true, reservationProfile: tripDetails },
          });
        } else {
          toast.error("You are not allowed to edit the trip at this time");
        }
      }
    } else if (pageType === "operation") {
      if (status === "booked") {
        setAllotModal();
      } else if (status === "alloted") {
        setDipatchmodal();
      }
      else if (status === "cancelled") {
        navigate(
          `/operation/billing/performa-invoice?tripId=${tripDetails?.id}&companyId=${tripDetails?.companyId}&companyName=${tripDetails?.companyName}&cityId=${tripDetails?.city}&cityName=${tripDetails?.location}&status=${tab}&page=${page}&pageRowSize=${rowPerPage}&startDate=${startDate}&endDate=${endDate}&billingType=${parseInt(details?.billingType) === billingTypeEnum?.billToCompany ? "billToCompany" : "billToCreditCard"}&pageType=generateInvoice`
        );
      }
    }
  };

  const handleDialog = (event) => {
    setOpen(event.currentTarget);
  };

  const handleMoreIcon = () => {
    const status = ["cancelled", "completed", "ongoing", "closed"];
    if(!accessForDispatchCancel){
      status.push('dispatched')
    }
    if (!status.includes(tripStatus)) {
      return true;
    }
  };


  const filterValue = (key) => {

    const keys = ["Reporting Address", "Drop Address", "Via Address", "Landmark", "Special Instruction", "Trip Charges", "Flight No","Cancellation Reason"]

    if (key === "Special Instruction" && tripDetails?.DriverProfile) {
      return "";
    }
    else if (keys.includes(key)
    ) {
      return "expandRow";
    }
  };

  const handleBackBtn = () => {

    const allRidesTab = ["all", "booked", "closed", "cancelled", "completed"];

    if(pageType === "operation") {
      if(type === "allrides" ) {
        const navigateStatus = tab === "all" ? "all" : allRidesTab?.includes(tab) ? tripStatus : null;
        navigate(`/operation/${type}/${navigateStatus}?startDate=${startDate || null}&endDate=${endDate || null}&page=${page}&rowsPerPage=${rowPerPage}&search=${search || ""}`);
      }
      else if (type === "allot" || type === "dispatch") {
        navigate(`/operation/${type}?startDate=${startDate || null}&endDate=${endDate || null}&page=${page}&rowsPerPage=${rowPerPage}&search=${search || ""}`);
      }
    }
    else {
      navigate(-1);
    }   
  }

  return (
    <>
      {reservationDataLoading ? (
        <Loader />
      ) : (
        <Box>
          <Grid container className="pb20 justifyBetween">
            <Box className="flex" alignItems={"center"}>
              <ArrowBackIosRoundedIcon
                className="font24 colorGrey"
                role="presentation"
                onClick={() => handleBackBtn()}
              />
              <Typography variant={"head4"} className="colorPrimary pl10">
                Booking ID {tripDetails?.tripId}
              </Typography>
            </Box>
            {btnName && (pageType === "reservation" ? reservationEdit :editAccess) && (
              <CommonButton
                name={btnName}
                iconType={`${btnName.toLowerCase()}`}
                iconPlace="front"
                btnClass={`btnSm`}
                disabled={handleDisabledBtn(btnName)}
                onClick={() => actionBtn(tripStatus, tripDetails)}
              />
            )}
          </Grid>
          <Box className="dashedBorderBottom"></Box>
          <Grid container justifyContent={"center"}>
            <Grid item xs={11}>
              <Grid container className="ptb30 justifyBetween">
                <Typography variant="head5" className="fw600 colorBlack">
                  Booking Details&nbsp;
                  <span className="font14 fw400">
                    ({getDateFormat(tripDetails?.updatedAt, "fromNowFormat")})
                  </span>
                </Typography>

                {tripStatus === "completed" && (
                  <Typography variant={"head5"} className="colorPrimary fw600">
                    Total Trip Charges - ₹&nbsp;
                    {formatCurrency(tripDetails?.finalPrice)}
                  </Typography>
                )}
                {handleMoreIcon() && cancelAccess && (
                  <IconButton
                    aria-label="open drawer"
                    edge="start"
                    onClick={(event) => handleDialog(event)}
                    className="pl25"
                  >
                    <MoreIcon />
                  </IconButton>
                )}
              </Grid>

              <Grid container className="ptb20 mb20 bgLightOrange">
                {bookingTime &&
                  bookingTime(tripDetails).map((data, index) => (
                    <Grid
                      key={index}
                      item
                      xs={12}
                      sm={3}
                      sx={{
                        padding: { xs: "20px 0px 0px 20px", sm: "0px" },
                        justifyContent: { xs: "flex-start", sm: "center" },
                      }}
                      container
                      className="justifyCenter"
                    >
                      <Box className="flex">
                        <img src={data.img} alt="Logo" />
                      </Box>
                      <Typography variant={"body2"} className="colorBlack pl20">
                        {data.title || "NA"}
                      </Typography>
                    </Grid>
                  ))}
              </Grid>

              <Grid container className="mt40 mb20">
                {bookingDetailsData(tripDetails, details) &&
                  bookingDetailsData(tripDetails, details).map((value, key) => (
                    <Grid
                      key={key}
                      item
                      xs={12}
                      md={filterValue(value?.title, value?.status) ? 12 : 6}
                      sx={{ display: value?.title ? "flex" : "none" }}
                      container
                    >
                      <Grid
                        xs={4}
                        md={filterValue(value?.title, value?.status) ? 2 : 4}
                        item
                        className="p20 alignStart gridBorder"
                      >
                        <Typography variant={"body2"} className="colorGrey">
                          {value.title || "NA"}
                        </Typography>
                      </Grid>

                      <Grid
                        xs={8}
                        md={filterValue(value?.title, value?.status) ? 10 : 8}
                        item
                        flexWrap={"wrap"}
                        className="p20 alignStart gridBorder"
                      >
                        <Typography
                          variant={`${
                            value?.textType === "textBold" ? "head5" : "body2"
                          }`}
                          className={`pr10 ${
                            value?.textType === "textBold" && "fw700"
                          }`}
                        >
                          {value.data || "NA"}
                           {/* Add Multi-day indicator for Duty Type */}
                          {value.title === "Duty Type" && tripDetails?.additionalInfo?.isMultiDay && (
                            <span className="font12 fontNormal colorGrey">
                              {' (Multi-day)'}
                            </span>
                          )}
                        </Typography>
                        {value?.inclusive && (
                          <Typography variant={"body3"} className={"colorGrey"}>
                          (Exclusive of GST and Toll & Parking)
                          </Typography>
                        )}
                        {value.title === "Passenger Name" && value.isVip && (
                          <Typography variant={"body5"} className="vipBadge">
                            VIP
                          </Typography>
                        )}
                      </Grid>
                    </Grid>
                  ))}
              </Grid>
              {tripStatus === "completed" ? (
                <img
                  src={tripDetails?.tripRouteImage?.url}
                  alt="map"
                  className="width100 height400"
                />
              ) : (
                <>
                  <Typography
                    variant="head5"
                    component={"h2"}
                    className="colorBlack fw600 mb20"
                  >
                    Facilities
                  </Typography>

                  <Grid container className="mt30 mb20">
                    {CabFacilities?.length ? (
                      CabFacilities?.map((row, index) => (
                        <Grid
                          item
                          md={2.4}
                          sm={6}
                          xs={12}
                          key={index}
                          className="facilityDashBoarder"
                        >
                          <Box className="justifyCenter ptb20">
                            <Box className="flex" alignItems={"center"}>
                              <img
                                src={row?.img?.url}
                                alt="Logo"
                                className="width40 height40 objectFit"
                                onError={(e) => handleOnError(e, row?.name)}
                              />
                            </Box>
                            <Typography
                              variant="body2"
                              className="colorGrey pl20"
                            >
                              {row?.name || "NA"}
                            </Typography>
                          </Box>
                        </Grid>
                      ))
                    ) : (
                      <Typography variant="body2" className="colorGrey pl20">
                        No Facilites Available
                      </Typography>
                    )}
                  </Grid>
                </>
              )}
            </Grid>
            {(tripStatus === "booked" ||
              tripStatus === "alloted" ||
              tripStatus === "dispatched"||
              tripStatus === "pending") && (
              <Grid className="colorGrey font18 mb30 justifyCenter" container>
                <Grid item xs={11}>
                  <Typography variant="head5" className="fw600 colorBlack">
                    Cancellation Note
                  </Typography>
                  <li>
                    There will be no cancellation charge if the trip is
                    cancelled before 2 hours of the scheduled time.
                  </li>
                  <li>
                    There will be minimum cancellation charge if the trip is
                    cancelled after 2 hours of the scheduled time.
                  </li>
                </Grid>
              </Grid>
            )}

          <AssignmentActionDetails 
            assignmentActions={tripDetails?.additionalInfo?.assignmentAction}
            currentVehicleType={tripDetails?.Vehicle?.carType || tripDetails?.DriverProfile?.Vehicle?.carType}
          />

          </Grid>

          <AllotVehicleModal
            open={allotModal}
            toggle={setAllotModal}
            tripDetails={tripDetails}
            page={"details"}
          />

          <DispatchModal
            open={dispatchModal}
            toggle={setDipatchmodal}
            tripDetails={tripDetails}
            page={"details"}
          />

          <CommonTableDialog
            menuData={dialogMenu}
            open={open}
            setOpen={setOpen}
            data={tripDetails}
          />


        </Box>
      )}
    </>
  );
};

export default BookingDetails;
